import type { InjectionKey, Ref } from 'vue';

/** Row drop indicator state shared between OutlinePanel and OutlineNode. */
export interface OutlineDrop {
    id: string;
    zone: 'before' | 'after' | 'into';
}

export const OUTLINE_DROP_KEY: InjectionKey<Ref<OutlineDrop | null>> = Symbol('builder-v2-outline-drop');
